'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/slicedToArray");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var objectToCamel = require('./lib/object-to-camel.js');

var configure = require('./lib/configure.js');

var multipartRequest = require('ipfs-core-utils/multipart-request');

var toUrlSearchParams = require('./lib/to-url-search-params.js');

var abortSignal = require('./lib/abort-signal.js');

var createAddAll = configure.configure(function (api) {
  function addAll(_x) {
    return _addAll.apply(this, arguments);
  }

  function _addAll() {
    _addAll = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(source) {
      var options,
          controller,
          signal,
          _ref,
          headers,
          body,
          total,
          parts,
          _ref2,
          _ref3,
          progressFn,
          onUploadProgress,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          file,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              controller = new AbortController();
              signal = abortSignal.abortSignal(controller.signal, options.signal);
              _context.next = 5;
              return _awaitAsyncGenerator(multipartRequest.multipartRequest(source, controller, options.headers));

            case 5:
              _ref = _context.sent;
              headers = _ref.headers;
              body = _ref.body;
              total = _ref.total;
              parts = _ref.parts;
              _ref2 = typeof options.progress === 'function' ? createProgressHandler(total, parts, options.progress) : [undefined, undefined], _ref3 = _slicedToArray(_ref2, 2), progressFn = _ref3[0], onUploadProgress = _ref3[1];
              _context.next = 13;
              return _awaitAsyncGenerator(api.post('add', {
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  'stream-channels': true
                }, options, {
                  progress: Boolean(progressFn)
                })),
                onUploadProgress: onUploadProgress,
                signal: signal,
                headers: headers,
                body: body
              }));

            case 13:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 16;
              _iterator = _asyncIterator(res.ndjson());

            case 18:
              _context.next = 20;
              return _awaitAsyncGenerator(_iterator.next());

            case 20:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 24;
              return _awaitAsyncGenerator(_step.value);

            case 24:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 37;
                break;
              }

              file = _value;
              file = objectToCamel.objectToCamel(file);

              if (!(file.hash !== undefined)) {
                _context.next = 33;
                break;
              }

              _context.next = 31;
              return toCoreInterface(file);

            case 31:
              _context.next = 34;
              break;

            case 33:
              if (progressFn) {
                progressFn(file.bytes || 0, file.name);
              }

            case 34:
              _iteratorNormalCompletion = true;
              _context.next = 18;
              break;

            case 37:
              _context.next = 43;
              break;

            case 39:
              _context.prev = 39;
              _context.t0 = _context["catch"](16);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 43:
              _context.prev = 43;
              _context.prev = 44;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 48;
                break;
              }

              _context.next = 48;
              return _awaitAsyncGenerator(_iterator.return());

            case 48:
              _context.prev = 48;

              if (!_didIteratorError) {
                _context.next = 51;
                break;
              }

              throw _iteratorError;

            case 51:
              return _context.finish(48);

            case 52:
              return _context.finish(43);

            case 53:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 39, 43, 53], [44,, 48, 52]]);
    }));
    return _addAll.apply(this, arguments);
  }

  return addAll;
});

var createProgressHandler = function createProgressHandler(total, parts, progress) {
  return parts ? [undefined, createOnUploadProgress(total, parts, progress)] : [progress, undefined];
};

var createOnUploadProgress = function createOnUploadProgress(size, parts, progress) {
  var index = 0;
  var count = parts.length;
  return function (_ref4) {
    var loaded = _ref4.loaded,
        total = _ref4.total;
    var position = Math.floor(loaded / total * size);

    while (index < count) {
      var _parts$index = parts[index],
          start = _parts$index.start,
          end = _parts$index.end,
          name = _parts$index.name;

      if (position < end) {
        progress(position - start, name);
        break;
      } else {
        progress(end - start, name);
        index += 1;
      }
    }
  };
};

function toCoreInterface(_ref5) {
  var name = _ref5.name,
      hash = _ref5.hash,
      size = _ref5.size,
      mode = _ref5.mode,
      mtime = _ref5.mtime,
      mtimeNsecs = _ref5.mtimeNsecs;
  var output = {
    path: name,
    cid: cid.CID.parse(hash),
    size: parseInt(size)
  };

  if (mode != null) {
    output.mode = parseInt(mode, 8);
  }

  if (mtime != null) {
    output.mtime = {
      secs: mtime,
      nsecs: mtimeNsecs || 0
    };
  }

  return output;
}

exports.createAddAll = createAddAll;